import worldMap from "@/assets/world-map.webp.asset.json";

/** Fundo padrão da landing (sempre escura): mapa-múndi + varredura de radar. */
const FixedBackground = () => {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      {/* Base gradient background */}
      <div className="absolute inset-0 bg-background" />

      {/* World Map Background */}
      <div className="absolute inset-0 opacity-40">
        <img
          src={worldMap.url}
          alt=""
          className="w-full h-full object-cover"
          decoding="async"
          width={1920}
          height={1080}
        />
      </div>

      {/* Subtle gradient overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-transparent to-background/60" />

      {/* Background Effects — blur/ping são pesados em GPU de celular; só md+ */}
      <div className="absolute inset-0 bg-grid-pattern opacity-15" />
      <div className="hidden md:block absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse-glow bg-primary/15" />
      <div className="hidden md:block absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full blur-3xl animate-pulse-glow bg-accent/10" style={{ animationDelay: "1.5s" }} />

      {/* Radar Scanning Animation (só md+; no celular fica o mapa + grade) */}
      <div className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px]">
        <div className="absolute inset-0 border-4 rounded-full animate-ping border-primary/30" style={{ animationDuration: "3s" }} />
        <div className="absolute inset-12 border-2 rounded-full animate-ping border-primary/25" style={{ animationDuration: "3s", animationDelay: "0.5s" }} />
        <div className="absolute inset-24 border-2 rounded-full animate-ping border-primary/20" style={{ animationDuration: "3s", animationDelay: "1s" }} />
        <div className="absolute inset-36 border rounded-full animate-ping border-primary/15" style={{ animationDuration: "3s", animationDelay: "1.5s" }} />
        <div className="absolute inset-48 border rounded-full animate-ping border-primary/10" style={{ animationDuration: "3s", animationDelay: "2s" }} />
        {/* Radar Sweep Effect */}
        <div className="absolute inset-0 rounded-full overflow-hidden">
          <div
            className="absolute top-1/2 left-1/2 w-1/2 h-1 bg-gradient-to-r to-transparent origin-left from-primary/50"
            style={{
              animation: "spin 4s linear infinite",
              transformOrigin: "0% 50%"
            }}
          />
        </div>
        {/* Center Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 rounded-full blur-md animate-pulse bg-primary/50" />
      </div>
    </div>
  );
};

export default FixedBackground;
